import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { MemberService } from '../../../backend/api/member.service';
import { MemberRequestDto } from '../../../backend/model/memberRequestDto';
import { SexEnum } from '../../../backend/model/sexEnum';
import { BaseComponent } from '../../../core/components/base/base.component';
import { DialogRef } from '../../../core/dialog/dialog-ref';
import { DialogConfig } from '../../../core/dialog/dialog.service';
import { AuthService } from '../../../core/services/auth.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  templateUrl: './save-member-dialog.component.html',
  //   styleUrls: ['./save-user-dialog.component.scss'],
})
export class SaveMemberDialogComponent extends BaseComponent {
  SexEnum = SexEnum;
  form = new UntypedFormGroup({});
  id = 0;
  familyId = 0;
  isLoading = false;
  isSaving = false;

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private t: TranslateService,
    private membersService: MemberService,
    authService: AuthService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
    const config = this.dialogConfig;
    this.id = config.data?.id;
    this.familyId = config.data?.familyId;

    this.form = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      sex: new UntypedFormControl(this.SexEnum.Female),
      dateOfBirth: new UntypedFormControl(null, [Validators.required]),
      note: new UntypedFormControl(''),
      familyId: new UntypedFormControl(0),
      id: new UntypedFormControl(0),
    });

    if (this.id) {
      this.loadUser(this.id);
    }
  }

  loadUser(id: number) {
    this.isLoading = true;

    this.membersService.apiMemberIdGet({ id }).subscribe(
      (res) => {
        this.isLoading = false;
        this.form.patchValue({
          name: res.name,
          sex: res.sex,
          dateOfBirth: res.dateOfBirth,
          note: res.note,
          familyId: res.familyId,
          id: res.id
        });
      },
      () => {
        this.isLoading = false;
        this.close();
      }
    );
  }

  close(saved?: boolean) {
    this.dialogRef.close({ saved });
  }

  save() {
    if (!this.form.valid) {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
      return;
    }

    const data: MemberRequestDto = {
      familyId: this.form.value.familyId || this.familyId,
      name: this.form.value.name,
      sex: this.form.value.sex,
      dateOfBirth: this.form.value.dateOfBirth,
      note: this.form.value.note,
      id: this.form.value.id
    };

    const apiCall = this.id
      ? this.membersService.apiMemberPut({
          memberRequestDto: data,
        })
      : this.membersService.apiMemberPost({ memberRequestDto: data });

    this.isSaving = true;

    apiCall.subscribe(
      (res) => {
        this.isSaving = false;
        this.close(true);
      },
      (err: any) => {
        this.isSaving = false;
        this.errorHandler(err, this.form);
      }
    );
  }

  disabledEndDate = (endValue: Date): boolean => {
    if (endValue.getDate() < new Date().getDate()) {
      return false;
    }

    return true;
  }
}
